import { render, staticRenderFns } from "./otherPriceTotal.vue?vue&type=template&id=c7ed757e&"
import script from "./otherPriceTotal.vue?vue&type=script&lang=js&"
export * from "./otherPriceTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports